export const serialize = (obj: {[key: string]: any}) => Object.keys(obj).reduce((acc, key, i) => {
    if (key in obj && obj[key] !== '') {
      acc += `${i === 0 ? '' : '&'}${key}=${encodeURIComponent(obj[key])}`;
    }
    return acc;
  }, '');
